var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKakao = function SvgKakao(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "kakao_svg__a",
    width: 21,
    height: 19,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M.5.357h19.88v18.264H.5z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#kakao_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#381E1F",
    fillRule: "evenodd",
    d: "M20.231 6.866c-.81-3.697-4.884-6.509-9.79-6.509C5.531.357 1.458 3.17.648 6.866.553 7.304.5 7.755.5 8.216c0 2.824 1.886 5.3 4.716 6.686-.208.776-.753 2.811-.862 3.247-.135.54.198.533.416.388.17-.114 2.724-1.85 3.825-2.599q.899.136 1.845.136c5.49 0 9.94-3.519 9.94-7.859q-.002-.69-.149-1.35",
    clipRule: "evenodd"
  }))));
};
export default SvgKakao;